import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './services/api.service';
import { LegacyUrlService } from './services/legacy-url.service';
import { LanguageService } from './services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'IU Press Anonymous Angular';

  constructor(
    public router: Router,
    private translateService: TranslateService,
    private apiService: ApiService,
    private legacyUrlService: LegacyUrlService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    // Check for legacy URL and redirect if necessary
    const currentUrl = this.router.url;
    // console.log('Current URL on app init:', currentUrl);
    
    // Extract language from legacy URL before redirect
    const legacyLang = this.legacyUrlService.extractLanguageFromUrl(currentUrl);
    
    // Handle legacy URL redirect (returns the language code if found)
    const detectedLang = this.legacyUrlService.handleLegacyUrl(currentUrl);
    
    // Set language based on legacy URL or use current language
    const langFromUrl = legacyLang || detectedLang;
    if (langFromUrl) {
      // console.log(`Setting language from legacy URL: ${langFromUrl}`);
      this.languageService.setLanguage(langFromUrl);
      this.translateService.use(langFromUrl);
      this.apiService.setCurrentLang(langFromUrl);
    } else {
      // No legacy URL, use current language
      const currentLang = this.translateService.getCurrentLang() || 'tr';
      this.translateService.use(currentLang);
      this.apiService.setCurrentLang(currentLang);
    }
  }
}